import { SelectionWithAddressMixin, SelectionWithMultimediaMixin, SelectionWithNoteSourceCitationMixin } from './mixin';
import { SelectionAny, SelectionDate, SelectionPlace } from './internal';
export class SelectionEvent extends SelectionWithAddressMixin(SelectionWithMultimediaMixin(SelectionWithNoteSourceCitationMixin(SelectionAny))) {
    valueAsHappened() {
        return this.value().map(v => v ? (v === "Y" /* ValueEvent.Yes */ ? true : null) : false);
    }
    getType() {
        return this.get("TYPE" /* Tag.Type */);
    }
    getDate() {
        return this.get("DATE" /* Tag.Date */, null, SelectionDate);
    }
    getPlace() {
        return this.get("PLAC" /* Tag.Place */, null, SelectionPlace);
    }
    getResponsibleAgency() {
        return this.get("AGNC" /* Tag.Agency */);
    }
    getReligiousAffiliation() {
        return this.get("RELI" /* Tag.Religion */);
    }
    getCause() {
        return this.get("CAUS" /* Tag.Cause */);
    }
}
//# sourceMappingURL=SelectionEvent.js.map